import { ManipulateType } from 'dayjs';

import { AutoDeletionAfterEnum } from 'features/Planner';
import i18n from 'i18next';

export const autoDeletionAfterDayjsValues: { [key in AutoDeletionAfterEnum]: { unit: ManipulateType; value: number } } =
	{
		[AutoDeletionAfterEnum.Never]: { unit: 'day', value: 0 },
		[AutoDeletionAfterEnum.OneDay]: { unit: 'day', value: 1 },
		[AutoDeletionAfterEnum.TwoDays]: { unit: 'day', value: 2 },
	};

export const autoDeletionAfterOptions = [
	{ label: i18n.t('Не удалять'), value: AutoDeletionAfterEnum.Never },
	{ label: i18n.t('Через день'), value: AutoDeletionAfterEnum.OneDay },
	{ label: i18n.t('Через 2 дня'), value: AutoDeletionAfterEnum.TwoDays },
];
